import { css } from 'lit';
import { fsDesignToken } from '../../../core/style-util.js';

export const style = css`
  .header-text {
    font-size: ${fsDesignToken('fsFontSizeLarge1')};
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    line-height: 36px;
    margin-bottom: 1rem;
    margin-top: 0;
  }

  .marketing-offer {
    background-color: ${fsDesignToken('fsColorFeedbackInfoSecondary')};
    border-radius: ${fsDesignToken('fsRadiusMedium')};
    font-size: ${fsDesignToken('fsFontSizeMedium1')};
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    padding: ${fsDesignToken('fsSizeSpacingMedium1')};
  }

  .search-button-container {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    width: 100%;

    @media (min-width: 768px) {
      align-items: center;
    }
  }

  .alert {
    margin-bottom: 1em;
  }

  h3 {
    font: 300 1.25em ${fsDesignToken('fsFontFamily')};
    margin-bottom: 1.5em;
    text-align: center;
  }

  .button-toggle-group {
    display: flex;
    flex-flow: column;
    margin: 1em 0 1em;

    .vehicle-lookup-type-button {
      width: calc(50% - 4px);
    }
  }

  .eligibility-link {
    display: block;
    margin-bottom: 1.5em;
  }

  .shared-vehicle-lookup__submit-container {
    display: flex;
    justify-content: center;

    .shared-vehicle-lookup__submit {
      flex: 0;
    }
  }
`;
